import { Box, Grid, useMediaQuery } from "@mui/material";
import { sectionWrapperSx } from "./sectionWrapper";
import { Datagrid, DateField, FunctionField, ReferenceField, TextField } from "react-admin";
import { settings } from "app";
import { employeeRequests } from "api/employeeApi";

const HistoryData = ({ historyOfChangedStatuses }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <Box sx={sectionWrapperSx}>
      <Grid
        container
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
        >
          <Datagrid
            data={historyOfChangedStatuses}
            rowClick={false}
            bulkActionButtons={false}
            sx={{ margin: 2, ...settings.style.secondaryDatagrid }}
          >
            <TextField
              source="status"
              label="Статус"
            />
            <TextField
              source="reason"
              label="Основание"
            />
            <TextField
              source="orderNumber"
              label="Номер на заповед"
            />
            <TextField
              source="orderDate"
              label="Дата на заповед"
            />

            <DateField
              source="changedOn"
              label="Променено на"
              showTime
              locales="bg-BG"
            />
            <ReferenceField
              source="changedByUserId"
              reference={employeeRequests.getEmployeesSelect()}
              label="Сменен от"
            >
              <FunctionField
                render={rec =>
                  rec.secondName
                    ? `${rec.firstName} ${rec.secondName} ${rec.lastName}`
                    : `${rec.firstName} ${rec.lastName}`
                }
              />
            </ReferenceField>
          </Datagrid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default HistoryData;
